<template>
  <div class="animated fadeIn">
    <div id="Dashboard">Dashboard
      
    </div>
  </div>
</template>

<script>

export default {
  name: 'dashboard'
}
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
